import { Dispatch } from 'redux';

import { fetcher } from '../../lib/request';

import { OrderLinkParams } from '../../models/Flight/OrderLink';

const AWAD_HOST = process.env.REACT_APP_AWAD_HOST;
const AWAD_KEY = process.env.REACT_APP_AWAD_KEY;

export const LINK_REQUEST = 'FLIGHT_LINK_REQUEST';
export const LINK_RESPONSE = 'FLIGHT_LINK_RESPONSE';
export const LINK_ERROR = 'FLIGHT_LINK_ERROR';

export const getOrderLinkAction = (params: OrderLinkParams) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: LINK_REQUEST
    });

    try {
        const response = await fetcher(`${AWAD_HOST}/v3/orders`)
            .post(params)
            .contentType('application/json')
            .auth(`Basic ${AWAD_KEY}`)
            .json();

        dispatch({
            type: LINK_RESPONSE,
            response: response
        });
    } catch (error) {
        dispatch({
            type: LINK_ERROR,
            error: error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Flight/orders.ts